<template>
	<AspectTableSingleAdd />
</template>

<script>
import AspectTableSingleAdd from "@/components/AspectTable/AspectTableSingle/AspectTableSingleAdd";

export default {
	name: "AspectPageSingleAdd",
	components: {
		AspectTableSingleAdd
	}
}
</script>

<style scoped>

</style>